<template>
  <div class="page">
    <div v-if="exchangeList.length == 0" class="nodata">
      <div class="nodata-container">
        <img src="./images/no_data.png" alt />
        <div class="S6 T3">您还没有兑换记录</div>
      </div>
    </div>

    <template v-else>
      <div class="top S6 T3 flex">
        <div>兑换记录</div>
        <div>操作日期</div>
      </div>
      <ul class="list">
        <li
          class="list-item flex B1"
          v-for="(item, index) in exchangeList"
          :key="index"
          @click="linkTo(item)"
        >
          <div>
            <span class="title S8 T1">{{ item.typeName }}</span>
            <span class="T3">（{{ item.title }}）</span>
          </div>
          <div class="T3 S7">
            {{ dayjs(item.createTime).format('YYYY-MM-DD') }}
          </div>
        </li>
      </ul>
    </template>
    <div class="footer B1" @click="show">
      <div class="change T5 S8 B_C5">兑换邀请码</div>
    </div>
    <van-dialog
      v-model="showDialog"
      class="change-dialog B1"
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <div class="title S8 T1">
        兑换邀请码
        <img src="./images/close.png" alt="" class="close" @click="hide" />
      </div>
      <div class="relative">
        <input
          type="text"
          v-model="code"
          class="change-input S6 T1 B6"
          @input="code = code.replace(/[\u4E00-\u9FA5]/g, '')"
          placeholder="请输入邀请码（不区分大小写）"
        />
        <img
          src="./images/circle_close.png"
          alt=""
          class="clear"
          v-if="code"
          @click="clear"
        />
      </div>
      <div
        class="to-change T5 S8 B_C5"
        :class="{ disabled: !code }"
        @click="toChange"
      >
        立即兑换
      </div>
    </van-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs
} from '@vue/composition-api'
import api from '@/api/api'
import dayjs from 'dayjs'
import { Log, openurl, getClientInfo } from '@em/ym'
import { Toast, Dialog } from 'vant'
import { isGuest } from '@/api/appInfo'
import util from '@/util/util'
import { requestappInfo } from '@/api/appInfo'
export default defineComponent({
  components: {
    'van-dialog': Dialog.Component
  },
  setup() {
    const state = reactive({
      exchangeList: [],
      showDialog: false,
      code: ''
    })
    onMounted(() => {
      Log.pageView({
        pageId: 'Html:YktAppExchangeCenter'
      })
      requestappInfo()
      getHistory()

      window.onResume(() => {
        requestappInfo()
        getClientInfo(() => {
          getHistory()
        })
      })
    })
    function getHistory() {
      api.exchange.getHistory().then(res => {
        const { detail, result } = res
        if (result.code == 0) {
          state.exchangeList = detail
        }
      })
    }
    function linkTo(data) {
      Log.click({
        eventId: 'LinkToLive',
        eventData: {
          title: data.title
        }
      })
      openurl(data.route)
    }
    function toChange() {
      if (state.code) {
        Log.click({
          eventId: 'ClickToChange',
          eventData: {
            title: '兑换邀请码'
          }
        })
        api.exchange.toExchange(state.code).then(res => {
          const { result } = res
          if (result.code == 0) {
            Toast('兑换成功')
            getHistory()
            hide()
          } else {
            Toast(result.msg)
          }
        })
      }
    }
    function clear() {
      state.code = ''
    }
    function show() {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
      state.showDialog = true
    }
    function hide() {
      state.showDialog = false
    }
    return {
      ...toRefs(state),
      dayjs,
      linkTo,
      toChange,
      clear,
      show,
      hide
    }
  }
})
</script>
<style lang="scss" scoped>
.page {
  background-color: #efeff4;
  height: 100vh;
}
.top {
  padding: 24px 29px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: #efeff4;
}
.relative {
  position: relative;
}
.list {
  padding-bottom: 120px;
  padding-top: 80px;
}
.list-item {
  padding: 29px;
  border-bottom: 1px solid#ebebeb;
}
.list-item:last-child {
  border-bottom: none;
}
.footer {
  width: 750px;
  height: 120px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.change {
  width: 690px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border-radius: 40px;
}
.change-dialog {
  width: 600px;
  height: 422px;
  padding: 55px 30px;
  border-radius: 16px;
  box-sizing: border-box;
}
.change-input {
  width: 540px;
  margin: 55px 0;
  padding: 25px;
  border-radius: 10px;
  border: none;
  box-sizing: border-box;
}
.to-change {
  width: 540px;
  height: 88px;
  border-radius: 44px;
  text-align: center;
  line-height: 88px;
  &.disabled {
    opacity: 0.4;
  }
}
.title {
  text-align: center;
}
.close {
  width: 24px;
  float: right;
}
.clear {
  width: 32px;
  position: absolute;
  top: calc(50% - 16px);
  right: 20px;
}
.flex {
  display: flex;
}
.nodata {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nodata-container {
  width: 100%;
  height: 249px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nodata-container img {
  width: 402px;
  height: 194px;
  margin-bottom: 27px;
}
</style>
